<template>
    <div class="modal fade" id="common-message-modal" ref="commonMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="commonMessageModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Message</h5>
                    <button type="button" class="close" id="btnCloseCommon" v-on:click="closeCommonMsg()">&times;</button>
                </div>
                <div class="modal-body">
                    <p class="color-red" v-show="moduleErrorMsg != ''">{{moduleErrorMsg}}</p>
                    <p v-show="moduleMsg != ''">{{moduleMsg}}</p>
                    <template v-if="infoArr.length">
                        <template v-for="(info,key) in infoArr">
                            <a :key="'infokeyi' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'infokeyj' + key"> {{info}}</span>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"CommonMessage",
    data: () => ({
        moduleName:'',
        moduleErrorMsg:'',
        moduleMsg:'',
        infoArr:[],
    }),
    watch:{
        moduleErrorMsg:function(val) {
            var self = this;
            //display message modal
            if (val != '') {
                self.openCommonMsg();
            }
        }
    },
    mounted: function() {
        var self = this;
        self.moduleName = this.$parent.commonName;
        self.moduleErrorMsg = this.$parent.commonErrorMsg;
        self.moduleMsg = this.$parent.commonMsg;
        self.infoArr = this.$parent.commonArr;     

    },
    methods: {
        openCommonMsg() {
            var self = this;
            $("#common-message-modal").modal("show");
        },
        closeCommonMsg() {
            var self = this;
            self.moduleMsg = '';
            self.moduleErrorMsg = '';
            self.infoArr = [];
            $("#common-message-modal").modal("hide");
            self.$parent.isCommonMsg = false;
            self.$parent.commonErrorMsg = '';
            self.$parent.commonMsg = '';
            self.$parent.commonArr = [];
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/layout/CommonMessage.vue